import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FlexContainer } from '../../styled/layout.styled';

const StyledItemContainer = styled(FlexContainer)`
  width: 210px;
  height: 48px;
  background: ${({ visited }) => (visited ? '#22096c' : 'transparent')};
  cursor: pointer;
  padding: 12px 0 12px 24px;
  margin-bottom: 16px;
  border-radius: ${({ visited }) => (visited ? '4px' : '0px')};
  &:hover {
    background-color: #22096c;
    border-radius: 4px;
  }
  img {
    width: 18px;
  }
  transition: all 0.3s ease;
`;

const StyledP = styled.p`
  color: #f0ecff;
  margin: 0;
  padding-left: 9px;
`;

const SideNavMenuItem = ({
  name, location, path, image,
}) => (
  <>
    <StyledItemContainer visited={path.endsWith(location) ? 1 : 0} as={Link} to={location}>
      <img src={image} alt="" />
      <StyledP className="">{name}</StyledP>
    </StyledItemContainer>
  </>
);

SideNavMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default SideNavMenuItem;
